import React, { Component } from 'react';
import Slider from 'react-slick';
import language from '../../../assets/languages/language';
import { getIpAddress } from '../../../common/getIpAddress';
import ModalComponent from '../../Common/Modal';
import FrmSubscriptionCheck from '../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../RestAPI/PartnerSubscription/FrmSubscription';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import AlertMessage from '../../config/alertMessage';
import './FrmvideoLessons.css';
import { flowPlayerVideoLessonUrl } from '../../../common/constant';

class FrmvideoLessons extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);
    this.state = {
      alert_status: false,
      MessageTitle: `<i class="icon-info icons font-2xl d-block "></i>`,
      MessageContent: AlertMessage.messageContent_frm,
      chapters: [],
      frm2chapters: [],
      allChapters: [],
      idname: '',
      token: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 10,
      Allchapters: [],
      itemData: [],
      subscription_details: '',
      subscription_details_for_isActive: '',
      showFreePremium: true,
      selectedmenu: 'frm',
      exams: [],
      lastRecord: '',
      lastAttempt: true,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      lastRecord1: '',
      lastAttempt1: true,
      showFreePremium1: true,
      showCapsules: true,
    };
  }

  slider;
  static contextTypes = { router: React.PropTypes.object };

  toggleAlert = () => {
    this.setState({ alert_status: !this.state.alert_status });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  getReadings = async (chapter, event, level) => {
    const chapterNumber = chapter.chapter_no;
    const premium = level === 1 ? this.state.showFreePremium : this.state.showFreePremium1;
    let capsulePremium;
    if (chapterNumber === 11 && level === 1 && this.state.showFreePremium1 === false) {
      capsulePremium = false;
    } else {
      capsulePremium = true;
    }
    const txt = chapterNumber.toString();
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      chapter_id: txt,
    };
    FD.callAPI(`${App_data.backend_api}/frm_question_bank/getcfavideosChapterwise`, data).then(
      async resp => {
        if (resp.success) {
          if (premium === true) {
            if (capsulePremium === false) {
              this.context.router.push({
                pathname: `/frm/videodisplay/${resp.cfavchapterfirst.id}/${premium ? 0 : 1}/${
                  resp.cfavchapterfirst.chapter_id
                }/${chapter.chapter_no}`,
                search: `?showCapsules=${this.state.showCapsules}&level=${level}`,
                state: {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapter: { chapter_id: chapter.chapter_no },
                  level,
                  showCapsules: this.state.showCapsules,
                },
              });
            } else {
              this.toggleAlert();
            }
          } else if (premium === false) {
            this.context.router.push({
              pathname: `/frm/videodisplay/${resp.cfavchapterfirst.id}/${premium ? 0 : 1}/${
                resp.cfavchapterfirst.chapter_id
              }/${chapter.chapter_no}`,
              search: `?showCapsules=${this.state.showCapsules}&level=${level}`,
              state: {
                token: this.state.token,
                idname: this.state.idname,
                chapter: { chapter_id: chapter.chapter_no },
                level,
                showCapsules: this.state.showCapsules,
              },
            });
          }
        } else {
        }
      },
    );
  };

  iframe = { padding: 10 };

  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    await FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
            showFreePremium1: true,
          });
        } else {
          const examIds = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: examIds,
          };
          await FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                let isSubscribed = false;
                const examPlanData = resp_exam.examPlan[0];
                isSubscribed = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  1,
                  exam_data,
                  examPlanData,
                );
                if (isSubscribed) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
                // var exam_data = resp_exam.examData;
                let isSubscribed1 = false;
                isSubscribed1 = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                  2,
                  exam_data,
                  examPlanData,
                );
                if (isSubscribed1) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }
                if (isSubscribed || isSubscribed1) {
                  this.setState({ showCapsules: false });
                } else {
                  this.setState({ showCapsules: true });
                }
              } else {
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({
            showFreePremium: true,
            showFreePremium1: true,
          });
        } else {
          const subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({ subscription_details });
          const examIds = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          const dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: examIds,
          };
          await FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
            resp_exam => {
              if (resp_exam.success) {
                const exam_data = resp_exam.examData;
                let isSubscribed = false;
                isSubscribed = FrmSubscriptionCheck.checkFrmVideosSubscription(1, exam_data);

                if (isSubscribed) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
                // var exam_data = resp_exam.examData;
                let isSubscribed1 = false;
                isSubscribed1 = FrmSubscriptionCheck.checkFrmVideosSubscription(2, exam_data);
                if (isSubscribed1) {
                  this.setState({ showFreePremium1: false });
                } else {
                  this.setState({ showFreePremium1: true });
                }
                if (isSubscribed || isSubscribed1) {
                  this.setState({ showCapsules: false });
                } else {
                  this.setState({ showCapsules: true });
                }
              } else {
              }
            },
          );
        }
      }
    });

    const dataExam = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(`${App_data.backend_api}/checkout_v1/getExams`, dataExam).then(resp => {
      if (resp.success) {
        this.setState({ ValidToken: true, exams: resp.exams[1] });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    // let data_data = {
    //   token: storage_session['token'],
    //   idname: storage_session['idname'],
    // };
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getcfaVideos`, dataExam).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, chapters: resp.cfavideo });
        } else {
          this.setState({ ValidToken: false });
        }
        // return resp;
      },
    );
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getfrm2Videos`, dataExam).then(
      resp => {
        if (resp.success) {
          this.setState({ ValidToken: true, frm2chapters: resp.cfavideo });
        } else {
          this.setState({ ValidToken: false });
        }
        // return resp;
      },
    );

    // get last watched video of frm 1
    await FD.callAPI(`${App_data.backend_api}/frm_question_bank/getlastViewedVideo`, dataExam).then(
      response => {
        if (response.success) {
          this.setState({
            lastRecord: response.data,
            lastAttempt: true,
          });
        }
      },
    );
    // get last watched video of frm 2
    await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/getlastViewedVideofrm2`,
      dataExam,
    ).then(response => {
      if (response.success) {
        this.setState({
          lastRecord1: response.data,
          lastAttempt1: true,
        });
      }
    });
  }
  goToVideo = async () => {
    const { lastRecord, lastAttempt } = this.state;
    if (lastAttempt) {
      this.context.router.push({
        pathname: `/frm/videodisplay/${lastRecord.frm_video.id}/${
          this.state.showFreePremium ? 0 : 1
        }/${lastRecord.frm_video.chapter_id === 0 ? 0 : 1}/${lastRecord.frm_video.chapter_id}/${
          lastRecord.videoIndex
        }`,
        search: `?showCapsules=${this.state.showCapsules}&level=${1}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecord.frm_video,
          index: lastRecord.videoIndex,
          showFreePremium: this.state.showFreePremium,
          showCapsules: this.state.showCapsules,
          level: 1,
        },
      });
    }
  };

  goToLastVideoFrm2 = async () => {
    const { lastRecord1, lastAttempt1 } = this.state;
    if (lastAttempt1) {
      this.context.router.push({
        pathname: `/frm/videodisplay/${lastRecord1.frm_video.id}/${
          this.state.showFreePremium1 ? 0 : 1
        }/${lastRecord1.frm_video.chapter_id === 0 ? 0 : 1}/${lastRecord1.frm_video.chapter_id}/${
          lastRecord1.videoIndex
        }`,
        search: `?showCapsules=${this.state.showCapsules}&level=${2}`,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapter: lastRecord1.frm_video,
          index: lastRecord1.videoIndex,
          showFreePremium: this.state.showFreePremium1,
          showCapsules: this.state.showCapsules,
          level: 2,
        },
      });
    }
  };

  render() {
    const { chapters, frm2chapters } = this.state;
    let data = '';
    const { lastAttempt, lastAttempt1 } = this.state;
    // frm 1 video lessons
    if (this.state.chapters.length) {
      data = chapters.map((item, index) => (
        <div className='col-sm-12 col-md-12' key={index}>
          <div className='card'>
            <div className='card-header card_header_bg' value={item.id}>
              <a
                className='pointer_class'
                id={item.chapter_name}
                value={item.id}
                onClick={this.getReadings.bind(this, item, item.chapter_name, 1)}
              >
                {item.chapter_no === 11 ? 'Concept Capsules' : language.LC().BOOK}{' '}
                {item.chapter_no === 11 ? '' : item.chapter_no} - {item.chapter_name}
              </a>
            </div>
            <div className='card-block list_icon_outer' key={item.chapter_name}>
              {item.Countvideos > 0 ? (
                <p>
                  {language.LC().TOTAL_VIDEOS}: {item.Countvideos}
                </p>
              ) : (
                <p />
              )}
              <div key={index} className='col-xs-12 col-sm-12 col-md-12'>
                <ChatperwiseReadingData
                  key={item.id}
                  item={item}
                  showFreePremium={this.state.showFreePremium}
                  showCapsules={this.state.showCapsules}
                />
              </div>
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    // frm 2 video lessons
    let data1 = '';
    if (this.state.frm2chapters.length) {
      data1 = frm2chapters /* .slice(4,11) */
        .map((item, index) => (
          <div className='col-sm-12 col-md-12' key={index}>
            <div className='card'>
              <div className='card-header card_header_bg' value={item.id}>
                <a
                  className='pointer_class'
                  id={item.chapter_name}
                  value={item.id}
                  onClick={this.getReadings.bind(this, item, item.chapter_name, 2)}
                >
                  {language.LC().BOOK} {/* item.chapter_no === 11 ? chapters.length :  */ index + 1}{' '}
                  - {item.chapter_name}
                </a>
              </div>
              <div className='card-block list_icon_outer' key={item.chapter_name}>
                {item.Countvideos > 0 ? (
                  <p>
                    {language.LC().TOTAL_VIDEOS}: {item.Countvideos}
                  </p>
                ) : (
                  <p />
                )}
                <div key={index} className='col-xs-12 col-sm-12 col-md-12'>
                  <ChatperwiseReadingData
                    key={item.id}
                    item={item}
                    showFreePremium1={this.state.showFreePremium1}
                    showCapsules={this.state.showCapsules}
                  />
                </div>
              </div>
            </div>
          </div>
        ));
    } else {
      data1 = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='video_lesson_wrap'>
        <div className='animated fadeIn'>
          <div className='row'>
            <div className=' frm_title_logo_wrap_Videos'>
              <h1 className='section_head'> {language.LC().FRM_LEVEL_I_LESSONS} </h1>
              <img
                src={`${App_data.frontend_url}/img/GARP_logo.png`}
                className='garpLogo'
                alt='full logo'
              />
              {lastAttempt ? (
                <button
                  className='btn btn-primary pointer_class'
                  onClick={this.goToVideo.bind(this)}
                  disabled={!lastAttempt}
                >
                  {' '}
                  {language.LC().GO_TO_MY_LAST_VIDEO_VIEWED}{' '}
                </button>
              ) : null}
            </div>

            <div className='col-xs-12 col-sm-12 col-md-12'>
              <div className='bank_wrapper'>
                <div className='row'>{data}</div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className=' frm_title_logo_wrap_Videos'>
              <h1 className='section_head'> {language.LC().FRM_LEVEL_II_LESSONS} </h1>
              {lastAttempt1 ? (
                <button
                  className='btn btn-primary pointer_class'
                  onClick={this.goToLastVideoFrm2.bind(this)}
                  disabled={!lastAttempt1}
                >
                  {' '}
                  {language.LC().GO_TO_MY_LAST_VIDEO_VIEWED}{' '}
                </button>
              ) : null}
            </div>
            <div className='col-xs-12 col-sm-12 col-md-12'>
              <div className='bank_wrapper'>
                <div className='row'>{data1}</div>
              </div>
            </div>
          </div>
          <ModalComponent
            goPremium={this.goPremium.bind(this)}
            toggleAlert={this.toggleAlert.bind(this)}
            alert_status={this.state.alert_status}
            MessageContent={this.state.MessageContent}
          />
        </div>
      </div>
    );
  }
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} style={{ ...style, display: 'block' }} onClick={onClick}>
      <img onClick={onClick} src='../../assets/img/right-arrow.svg' alt='' />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        fontSize: '60px',
        right: '80px',
        zIndex: '15',
        height: '20px',
        width: '40px',
        opacity: '1',
      }}
      onClick={onClick}
    >
      <img onClick={onClick} src='../../assets/img/left-arrow.svg' alt='' />
    </div>
  );
}

class ChatperwiseReadingData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allchapters: [],
      offset: 0,
      limit: 10,
      alert_status: false,
      MessageTitle: `<i class="icon-info icons font-2xl d-block "></i>`,
      MessageContent: AlertMessage.messageContent_frm,
      chapters: [],
      allChapters: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      Allchapters: [],
      itemData: [],
      videoUrl: '',
      srcUrl: '',
      srcUrl_final: '',
      selectedmenu: 'frm',
      showFreePremium: true,
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      showFreePremium1: true,
      showCapsules: this.props.showCapsules,
    };
  }

  static contextTypes = { router: React.PropTypes.object };

  toggleAlert = () => {
    this.setState({ alert_status: !this.state.alert_status });
  };

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  getReadings = async (chapter, index) => {
    await this.savelastVideo(chapter, index, chapter.level);
    // const result = getDeviceDetails();
    if (chapter.free === 1) {
      const data = {
        token: this.state.token,
        idname: this.state.idname,
        id: chapter.id,
        videoIndex: index,
        city: this.state.user_city,
        country: this.state.user_country,
        state: this.state.user_state,
        continent: this.state.user_continent,
        ip: this.state.user_ip,
      };
      FD.callAPI(`${App_data.backend_api}/frm_question_bank/trackUserVideowatch`, data).then(
        async resp => {
          if (resp.success) {
            if (chapter.level === 1) {
              this.context.router.push({
                pathname: `/frm/videodisplay/${chapter.id}/${this.state.showFreePremium ? 0 : 1}/${
                  chapter.chapter_id === 0 ? 0 : 1
                }/${chapter.chapter_id}/${index}`,
                search: `?showCapsules=${this.state.showCapsules}&level=${chapter.level}`,
                state: {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapter,
                  index,
                  showFreePremium: this.state.showFreePremium,
                  level: chapter.level,
                  showCapsules: this.state.showCapsules,
                },
              });
            } else {
              this.context.router.push({
                pathname: `/frm/videodisplay/${chapter.id}/${this.state.showFreePremium1 ? 0 : 1}/${
                  chapter.chapter_id === 0 ? 0 : 1
                }/${chapter.chapter_id}/${index}`,
                search: `?showCapsules=${this.state.showCapsules}&level=${chapter.level}`,
                state: {
                  token: this.state.token,
                  idname: this.state.idname,
                  chapter,
                  index,
                  showFreePremium: this.state.showFreePremium1,
                  level: chapter.level,
                  showCapsules: this.state.showCapsules,
                },
              });
            }
          } else {
          }
        },
      );
    } else {
      const data = { token: this.state.token, idname: this.state.idname };
      FD.callAPI(`${App_data.backend_api}/user/getProfileInfo`, data).then(resp => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.toggleAlert();
          } else {
            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              async resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // const selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  const examPlanData = resp_exam.examPlan[0];
                  if (chapter.chapter_id === 11) {
                    isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                      1,
                      exam_data,
                      examPlanData,
                    );
                    if (!isInArray_var) {
                      isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                        2,
                        exam_data,
                        examPlanData,
                      );
                    }
                  } else {
                    isInArray_var = await PartnerFRMSubscriptionCheck.checkFrmVideosSubscription(
                      chapter.level,
                      exam_data,
                      examPlanData,
                    );
                  }
                  if (isInArray_var) {
                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      `${App_data.backend_api}/frm_question_bank/trackUserVideowatch`,
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        if (chapter.level === 1) {
                          this.context.router.push({
                            pathname: `/frm/videodisplay/${chapter.id}/${
                              this.state.showFreePremium ? 0 : 1
                            }/${chapter.chapter_id === 0 ? 0 : 1}/${chapter.chapter_id}/${index}`,
                            search: `?showCapsules=${this.state.showCapsules}&level=${
                              chapter.level
                            }`,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter,
                              index,
                              showFreePremium: this.state.showFreePremium,
                              level: chapter.level,
                              showCapsules: this.state.showCapsules,
                            },
                          });
                        } else {
                          this.context.router.push({
                            pathname: `/frm/videodisplay/${chapter.id}/${
                              this.state.showFreePremium1 ? 0 : 1
                            }/${chapter.chapter_id === 0 ? 0 : 1}/${chapter.chapter_id}/${index}`,
                            search: `?showCapsules=${this.state.showCapsules}&level=${
                              chapter.level
                            }`,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter,
                              index,
                              showFreePremium: this.state.showFreePremium1,
                              level: chapter.level,
                              showCapsules: this.state.showCapsules,
                            },
                          });
                        }
                      } else {
                      }
                    });
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            return this.toggleAlert();
          } else {
            // const exam_selected = resp.profileInfo.exam_selected
            //   ? JSON.parse(resp.profileInfo.exam_selected)
            //   : resp.profileInfo.exam_selected;
            const subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({ subscription_details });

            const data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            const dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(`${App_data.backend_api}/checkout_v1/getExamsbyUser`, dataset).then(
              resp_exam => {
                if (resp_exam.success) {
                  const exam_data = resp_exam.examData;
                  // var selectedmen = this.state.selectedmenu;
                  let isInArray_var = false;
                  if (chapter.chapter_id === 11) {
                    isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(1, exam_data);
                    if (!isInArray_var) {
                      isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(2, exam_data);
                    }
                  } else {
                    isInArray_var = FrmSubscriptionCheck.checkFrmVideosSubscription(
                      chapter.level,
                      exam_data,
                    );
                  }
                  if (isInArray_var) {
                    const data = {
                      token: this.state.token,
                      idname: this.state.idname,
                      id: chapter.id,
                      videoIndex: index,
                      city: this.state.user_city,
                      country: this.state.user_country,
                      state: this.state.user_state,
                      continent: this.state.user_continent,
                      ip: this.state.user_ip,
                    };
                    FD.callAPI(
                      `${App_data.backend_api}/frm_question_bank/trackUserVideowatch`,
                      data,
                    ).then(async resp => {
                      if (resp.success) {
                        if (chapter.level === 1) {
                          this.context.router.push({
                            pathname: `/frm/videodisplay/${chapter.id}/${
                              this.state.showFreePremium ? 0 : 1
                            }/${chapter.chapter_id === 0 ? 0 : 1}/${chapter.chapter_id}/${index}`,
                            search: `?showCapsules=${this.state.showCapsules}&level=${
                              chapter.level
                            }`,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter,
                              index,
                              showFreePremium: this.state.showFreePremium,
                              level: chapter.level,
                              showCapsules: this.state.showCapsules,
                            },
                          });
                        } else {
                          this.context.router.push({
                            pathname: `/frm/videodisplay/${chapter.id}/${
                              this.state.showFreePremium1 ? 0 : 1
                            }/${chapter.chapter_id === 0 ? 0 : 1}/${chapter.chapter_id}/${index}`,
                            search: `?showCapsules=${this.state.showCapsules}&level=${
                              chapter.level
                            }`,
                            state: {
                              token: this.state.token,
                              idname: this.state.idname,
                              chapter,
                              index,
                              showFreePremium: this.state.showFreePremium1,
                              level: chapter.level,
                              showCapsules: this.state.showCapsules,
                            },
                          });
                        }
                      } else {
                      }
                    });
                  } else {
                    return this.toggleAlert();
                  }
                } else {
                }
              },
            );
          }
        }
      });
    }
  };

  savelastVideo = async (chapter, index, level) => {
    const { token, idname } = this.state;
    const data_data = {
      token,
      idname,
      video_id: chapter.id,
      videoIndex: index,
      level,
    };
    await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/saveLastViewedVideo`,
      data_data,
    ).then(response => {
      if (response.success) {
        this.setState({ ValidToken: true });
      }
    });
  };

  iframe = { padding: 10 };

  async componentDidMount() {
    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }
    this.setState({
      showFreePremium: this.props.showFreePremium,
      showFreePremium1: this.props.showFreePremium1,
    });
    const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    const payload = {
      token: storage_session['token'],
      chapter_id: this.props.item.chapter_no,
    };
    await FD.callAPI(
      `${App_data.backend_api}/frm_question_bank/getcfavideosChapterwise`,
      payload,
    ).then(resp => {
      if (resp.success) {
        this.setState({ allchapters: resp.cfavchapter });
      } else {
        this.setState({ allchapters: [], ValidToken: false });
      }
    });
  }

  videoSection = () => {
    let data = '';
    let count = 0;
    if (this.state.allchapters.length) {
      data = this.state.allchapters.map((item, index) => {
        return (
          <div key={index}>
            {item && item.level === 1 ? (
              <div>
                {/* {console.log('cap', this.state.showCapsules)} */}
                {item.chapter_id === 11 ? (
                  this.state.showCapsules ? (
                    item.free === 1 ? (
                      <div className='video-type-free'>{language.LC().FREE}</div>
                    ) : (
                      <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                    )
                  ) : (
                    <div />
                  )
                ) : this.state.showFreePremium ? (
                  item.free === 1 ? (
                    <div className='video-type-free'>{language.LC().FREE}</div>
                  ) : (
                    <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                  )
                ) : (
                  <div />
                )}
                {!item.url_id_qq ? (
                  <img
                    alt=''
                    width='100%'
                    src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                    value={index}
                    onClick={this.getReadings.bind(this, item, index)}
                    className='pointer_class slider_row'
                  />
                ) : (
                  <img
                    alt=''
                    width='100%'
                    src={
                      item.posterImage
                        ? item.posterImage
                        : `https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                            item.url_id_qq
                          }-1.jpg`
                    }
                    onError={({ currentTarget }) => {
                      if (!count++) {
                        // Added condition because of infinite loop, this will once only
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = `
                      https://cdn.flowplayer.com/b3390c02-b80b-44ff-acdb-befff01546ae/i/v-i-${
                        item.url_id_qq
                      }-1_2.jpg`;
                      }
                    }}
                    value={index}
                    onClick={this.getReadings.bind(this, item, index)}
                    className='pointer_class slider_row'
                  />
                )}

                <strong style={{ padding: '10px' }}> {item.title}</strong>
              </div>
            ) : (
              /* item.level === 2 ? */ <div key={index}>
                {this.state.showFreePremium1 ? (
                  item.free === 1 ? (
                    <div className='video-type-free'>{language.LC().FREE}</div>
                  ) : (
                    <div className='video-type-primum'>{language.LC().PREMIUM}</div>
                  )
                ) : (
                  <div />
                )}
                {!item.url_id_qq ? (
                  <img
                    alt=''
                    width='100%'
                    src={`https://img.youtube.com/vi/${item.url_id}/mqdefault.jpg`}
                    value={index}
                    onClick={this.getReadings.bind(this, item, index)}
                    className='pointer_class slider_row'
                  />
                ) : (
                  <img
                    alt=''
                    width='100%'
                    src={
                      item.posterImage
                        ? item.posterImage
                        : flowPlayerVideoLessonUrl(`${item.url_id_qq}-1`)
                    }
                    onError={({ currentTarget }) => {
                      if (!count++) {
                        // Added condition because of infinite loop, this will once only
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = flowPlayerVideoLessonUrl(`${item.url_id_qq}-1_2`);
                      }
                    }}
                    value={index}
                    onClick={this.getReadings.bind(this, item, index)}
                    className='pointer_class slider_row'
                  />
                )}

                <strong style={{ padding: '10px' }}> {item.title}</strong>
              </div>
            )}
          </div>
        );
      });
    } else {
      return null;
    }
    return data;
  };

  render() {
    const settings = {
      dots: true,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: false,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
          },
        },
      ],
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
    };
    return (
      <div>
        <Slider {...settings}>{this.videoSection()}</Slider>

        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
      </div>
    );
  }
}
export default FrmvideoLessons;



// WEBPACK FOOTER //
// ./src/views/FRM/FRMVideoLessons/FrmvideoLessons.js